import axios from 'axios';
import { createAuthHeaders } from '../../api-client';
import type { SupabaseAdvisorsResponse, SupabaseAdvisorType } from '@optidev/shared-types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export const debuggingApi = {
  /**
   * Get security or performance advisories for an OptiDev Cloud project
   * Returns lints with severity levels, descriptions, and remediation steps
   */
  async getAdvisors(
    token: string,
    projectId: string,
    type: SupabaseAdvisorType
  ): Promise<SupabaseAdvisorsResponse> {
    const response = await axios.get(
      `${API_URL}/api/supabase/projects/${projectId}/debugging-dashboard/advisors/${type}`,
      {
        headers: createAuthHeaders(token),
      }
    );
    return response.data;
  },

  /**
   * Get logs from a Supabase service
   * Supported services: api, postgres, edge-function, auth, storage, realtime
   */
  async getLogs(
    token: string,
    projectId: string,
    service: 'auth' | 'storage' | 'api' | 'postgres',
    limit: number = 100,
    interval: '15min' | '1hr' | '3hr' | '1day' = '1hr'
  ): Promise<{ data: Array<{ id: string; timestamp: string; event_message: string; metadata?: Record<string, unknown>[] }> }> {
    const response = await axios.get(
      `${API_URL}/api/supabase/projects/${projectId}/debugging-dashboard/logs/${service}?limit=${limit}&interval=${interval}`,
      {
        headers: createAuthHeaders(token),
      }
    );
    return response.data;
  },
};
